/* eslint-disable */
import _ from 'underscore';
var i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');
var dayOptions = [{
  val: 'AllDays',
  name: i18n.get('Globalization_Day_All_Days')
}, {
  val: 'Sunday',
  name: i18n.get('Globalization_Day_Sunday')
}, {
  val: 'Monday',
  name: i18n.get('Globalization_Day_Monday')
}, {
  val: 'Tuesday',
  name: i18n.get('Globalization_Day_Tuesday')
}, {
  val: 'Wednesday',
  name: i18n.get('Globalization_Day_Wednesday')
}, {
  val: 'Thursday',
  name: i18n.get('Globalization_Day_Thursday')
}, {
  val: 'Friday',
  name: i18n.get('Globalization_Day_Friday')
}, {
  val: 'Saturday',
  name: i18n.get('Globalization_Day_Saturday')
}, {
  val: 'MondayToFriday',
  name: i18n.get('Globalization_Day_Monday_To_Friday')
}];
var hourOptions = [{
  val: 0,
  twelveHourDisplay: i18n.get('Globalization_Time_12AM_Start_Of_Day')
}, {
  val: 1,
  twelveHourDisplay: i18n.get('Globalization_Time_1AM')
}, {
  val: 2,
  twelveHourDisplay: i18n.get('Globalization_Time_2AM')
}, {
  val: 3,
  twelveHourDisplay: i18n.get('Globalization_Time_3AM')
}, {
  val: 4,
  twelveHourDisplay: i18n.get('Globalization_Time_4AM')
}, {
  val: 5,
  twelveHourDisplay: i18n.get('Globalization_Time_5AM')
}, {
  val: 6,
  twelveHourDisplay: i18n.get('Globalization_Time_6AM')
}, {
  val: 7,
  twelveHourDisplay: i18n.get('Globalization_Time_7AM')
}, {
  val: 8,
  twelveHourDisplay: i18n.get('Globalization_Time_8AM')
}, {
  val: 9,
  twelveHourDisplay: i18n.get('Globalization_Time_9AM')
}, {
  val: 10,
  twelveHourDisplay: i18n.get('Globalization_Time_10AM')
}, {
  val: 11,
  twelveHourDisplay: i18n.get('Globalization_Time_11AM')
}, {
  val: 12,
  twelveHourDisplay: i18n.get('Globalization_Time_12PM')
}, {
  val: 13,
  twelveHourDisplay: i18n.get('Globalization_Time_1PM')
}, {
  val: 14,
  twelveHourDisplay: i18n.get('Globalization_Time_2PM')
}, {
  val: 15,
  twelveHourDisplay: i18n.get('Globalization_Time_3PM')
}, {
  val: 16,
  twelveHourDisplay: i18n.get('Globalization_Time_4PM')
}, {
  val: 17,
  twelveHourDisplay: i18n.get('Globalization_Time_5PM')
}, {
  val: 18,
  twelveHourDisplay: i18n.get('Globalization_Time_6PM')
}, {
  val: 19,
  twelveHourDisplay: i18n.get('Globalization_Time_7PM')
}, {
  val: 20,
  twelveHourDisplay: i18n.get('Globalization_Time_8PM')
}, {
  val: 21,
  twelveHourDisplay: i18n.get('Globalization_Time_9PM')
}, {
  val: 22,
  twelveHourDisplay: i18n.get('Globalization_Time_10PM')
}, {
  val: 23,
  twelveHourDisplay: i18n.get('Globalization_Time_11PM')
}, {
  val: 24,
  twelveHourDisplay: i18n.get('Globalization_Time_12AM_End_Of_Day')
}];
var minuteOptions = [{
  index: 0,
  minuteName: '00',
  val: 'ZERO'
}, {
  index: 1,
  minuteName: '15',
  val: 'FIFTEEN'
}, {
  index: 2,
  minuteName: '30',
  val: 'THIRTY'
}, {
  index: 3,
  minuteName: '45',
  val: 'FORTY_FIVE'
}];
var minuteOptionsMap = {
  0: minuteOptions[0],
  15: minuteOptions[1],
  30: minuteOptions[2],
  45: minuteOptions[3]
};
var bidAdjustmentOptions = [{
  val: -1,
  text: i18n.get('BidAdjustment_DecreaseText')
}, {
  val: 1,
  text: i18n.get('BidAdjustment_IncreaseText')
}];
var bidAdjustmentRange = {
  minBid: -90,
  maxBid: 900
};
var minuteToSaveMap = {
  ZERO: 0,
  FIFTEEN: 15,
  THIRTY: 30,
  FORTY_FIVE: 45
};
var minuteToReadMap = _.invert(minuteToSaveMap);
var errors = {
  endTimeBeyondEOD: {
    message: i18n.get('ImprovedAdScheduling_End_Time_Beyond_EOD'),
    type: 'ERROR_TIME'
  },
  startTimeEarlierThanEndTime: {
    message: i18n.get('ImprovedAdScheduling_Start_Time_Later_Than_End_Time'),
    type: 'ERROR_TIME'
  },
  bidExceedLimitation: {
    message: i18n.get('Row_Error_InvalidBidAdjustment').replace('{0}', bidAdjustmentRange.minBid * -1).replace('{1}', bidAdjustmentRange.maxBid),
    type: 'ERROR_BID'
  },
  bidEmpty: {
    message: i18n.get('AdvancedTargeting_Error_BidValueMustNotBeEmpty'),
    type: 'ERROR_BID'
  },
  bidIncorrectFormat: {
    message: i18n.get('AdvancedTargeting_Error_BidValueMustBeDecimal'),
    type: 'ERROR_BID'
  }
};
export default {
  dayOptions: dayOptions,
  hourOptions: hourOptions,
  minuteOptions: minuteOptions,
  minuteOptionsMap: minuteOptionsMap,
  bidAdjustmentRange: bidAdjustmentRange,
  bidAdjustmentOptions: bidAdjustmentOptions,
  minuteToSaveMap: minuteToSaveMap,
  minuteToReadMap: minuteToReadMap,
  errors: errors
};

